import React from 'react';
import GolferAuthLayout from './GolferAuthLayout';

const contacts = [
  { title: 'Support', email: 'support@privateiq.golf' },
  { title: 'Press', email: 'press@privateiq.golf' },
  { title: 'Partnerships', email: 'partnerships@privateiq.golf' },
];

const Contact = () => {
  return (
    <GolferAuthLayout
      seoTitle="Contact — PrivateIQ"
      seoDescription="Get in touch with the PrivateIQ team for support, press inquiries, or partnership opportunities."
      canonicalPath="/contact"
    >
      <div className="ga-auth-card wide">
        <div className="ga-auth-badge">Get in Touch</div>
        <h1 className="ga-auth-title">We're here to help.</h1>
        <p className="ga-auth-subtitle">
          Reach out to the right team using the email addresses below.
        </p>

        <div className="ga-contact-grid">
          {contacts.map((contact, index) => (
            <div className="ga-contact-item" key={index}>
              <h3>{contact.title}</h3>
              <a href={`mailto:${contact.email}`}>
                {contact.email}
              </a>
            </div>
          ))}
        </div>

        <p className="ga-contact-note">
          For immediate assistance, please allow 24-48 hours for a response. Our team is available
          Monday through Friday, 9 AM - 5 PM EST.
        </p>
      </div>
    </GolferAuthLayout>
  );
};

export default Contact;
